import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditProgram } from '../containers/Programs';
export default class EditProgramButton extends Component {

	state = {
		open: false
	};

	render() {

    const { program } = this.props;
    const { open } = this.state;
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{width:1050, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>{program.name}</span>
								</div>

							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
							<EditProgram editId={program._id} hideNavigationTabs={true}   />
						</div>
	        </div>
	      </Modal>
		    <span
          className="link"
          onClick={() => this.setState({open:true})}
          style={{float:'right'}}>
          <FontAwesomeIcon icon="edit" title={'Edit'}
            style={{marginRight: 5, color: COLORS.orange}}/>
        </span>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditProgramButton.js